import {
  QueryClient,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { PlayersQueryKeys } from '../../queryKey';
import { UserQueryKeys } from '@/api/user/queryKeys';
import { fetchUpdatePlayer } from './service';
import { UseUpdatePlayerProps } from './props';

import { useModalNavigation } from '@/hooks/modals/useModalNavigation';
import { Player } from '@/models/player';
import { ModalsKey } from '@/enums/modalsKey';
import { useNotificationService } from '@/hooks/notifications/useNotificationService';
import { PlayerTournamentScoresQueryKey } from '@/api/player-tournament-scores/queryKey';
import { useSearchParams } from '@starsoft/common/hooks';

export function useUpdatePlayer(props?: UseUpdatePlayerProps) {
  const { customOnSuccess } = props ?? {};
  const { navigateToModal } = useModalNavigation();
  const search: URLSearchParams = useSearchParams();
  const queryClient: QueryClient = useQueryClient();
  const { NotificationsService } = useNotificationService();

  function onSuccess(player: Player) {
    search.set('userSlug', player.slug);
    navigateToModal(ModalsKey.UserProfile, `?${search.toString()}`);
    queryClient.invalidateQueries({
      queryKey: [PlayersQueryKeys.Statistics],
    });
    queryClient.invalidateQueries({
      queryKey: [UserQueryKeys.Profile],
    });
    queryClient.invalidateQueries({
      queryKey: [PlayerTournamentScoresQueryKey.Me],
    });

    NotificationsService.success({
      title: 'update_player_success_title',
      message: 'update_player_success_title_description',
    });
    customOnSuccess?.(player);
  }

  const { mutate, isPending } = useMutation({
    mutationFn: fetchUpdatePlayer,
    onSuccess,
  });

  return {
    updatePlayer: mutate,
    isPending,
  };
}
